import * as React from 'react'

export const SvgAccountReferralsOutline = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M14 7.5a3.563 3.563 0 110 7.125A3.563 3.563 0 0114 7.5zm0 2a1.563 1.563 0 100 3.125A1.563 1.563 0 0014 9.5zm0 5.998c3.729 0 6.858 2.285 6.995 5.294l.005.206h-2c0-1.86-2.186-3.5-5-3.5-2.731 0-4.87 1.545-4.994 3.337L9 20.998H7c0-3.11 3.186-5.5 7-5.5zM10 3a3.563 3.563 0 013.522 3.024c-.656.06-1.334.26-1.962.604A1.563 1.563 0 109.88 8.12a5.176 5.176 0 00-.83 1.876A3.564 3.564 0 0110 3zm-.665 10.03c-2.406.225-4.216 1.661-4.33 3.305L5 16.498H3c0-2.816 2.613-5.042 5.938-5.437 0 .744.148 1.402.397 1.968z" />
  </svg>
)
export default SvgAccountReferralsOutline
